// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PharmuniRoadMap_wrapper__7fHnD","tab-list":"PharmuniRoadMap_tab-list__3t8T7","selected":"PharmuniRoadMap_selected__w1gBt"};